
import XButton from 'vux/src/components/x-button/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'

import config from '@/config/index'
import { getProductDetail } from '@/api/youzheng.js'
import { getintegral } from '@/api/user.js'
import { wxShare, getWxConfig } from '@/libs/utils.js'
import errorImg from '@/assets/mall/img-error.png'
export default {
name: 'productdetail',
components: {
XButton,
Divider,
Swiper
},
data () {
return {
searchVal: '',
baseUrl: config.baseUrl,
errorImg: errorImg,
id: this.$route.params.id,
goodsObj: {},
owner_type: config.owner_type
}
},
created () {
this.getDetail()
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
methods: {
onImgError ($event) {
$event.target.src = this.errorImg
},
getDetail () {
getProductDetail({
productid: this.id
}).then(res => {
this.goodsObj = res.returnValue
const link = window.location.href
const wxShareLink = this.baseUrl + 'servlet/ShareServlet?sicode=' + config.sicode + '&url=' + link
wxShare(res.returnValue.PRODNAME, wxShareLink, this.baseUrl + res.returnValue.TITLEIMG)
})
},
confirm () {
this.getTotalCredit()
},

getTotalCredit () {
getintegral({
accountid: this.accountid,
owner_type: '',
userid: this.userid
}).then(res => {
if (res.allnow < this.goodsObj.CREDIT) {
this.$vux.alert.show({
content: '您的当前积分不足，不能兑换！'
})
} else {
this.$router.push({ name: 'mallWechatPaySubmitOrders', params: { id: this.id } })
}
})
}
}
}
